import {
  API_ERROR_CODES,
  apiGetOneTimeToken,
  ONBOARDING_API_BASE_URL,
} from "./index.ts";

/**
 * Authenticate user with password
 * (the backend will use the session from previous identity search)
 */

type ApiLoginResult = {
  data?: {
    requiresOtp?: boolean;
    oneTimeToken?: string;
    p_id?: string;
  };
  errorCode?: API_ERROR_CODES;
  errorMessage?: string;
};

export const apiLogin = async (
  password: string,
  csrfToken: string,
  jid: string | null,
): Promise<ApiLoginResult> => {
  return fetch(`${ONBOARDING_API_BASE_URL}/auth/login`, {
    method: "POST",
    body: JSON.stringify({ password, jid }),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorMessage = await response.text();

        if (response.status === 429) {
          return {
            errorCode: API_ERROR_CODES.LOGIN_TOO_MANY_ATTEMPTS,
            errorMessage,
          };
        }

        if (response.status === 400 || response.status === 401) {
          return {
            errorCode: API_ERROR_CODES.LOGIN_GENERIC,
            errorMessage,
          };
        }

        return {
          errorCode: API_ERROR_CODES.GENERIC,
          errorMessage,
        };
      }

      const responseJson = await response.json();

      // if they don't need to do OTP we can fetch the one time token straight away
      let oneTimeToken = undefined;
      if (!responseJson.requiresOtp) {
        const {
          data: oneTimeTokenData,
          errorCode,
          errorMessage,
        } = await apiGetOneTimeToken(csrfToken);
        if (oneTimeTokenData) {
          oneTimeToken = oneTimeTokenData.oneTimeToken;
        } else if (errorCode) {
          return {
            errorCode,
            errorMessage,
          };
        }
      }

      return {
        data: {
          ...responseJson,
          oneTimeToken,
        },
      } as ApiLoginResult;
    })
    .catch(() => {
      return {
        errorCode: API_ERROR_CODES.GENERIC,
      };
    });
};
